import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ShareWrapper } from '../share/share-wrapper.component';
import { EventInformationData } from 'globals/store/share.data';
import { environment } from '../../../environments/environment';
import { take } from 'rxjs/operators';
import { InformablePublicComponent } from '../../components/informable/informable.public.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'share-event-information',
    template: `
<branding-wrapper
  [brandingData]="data?.brandingData" 
  [style.--sitebackground]="data?.brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div class="inner" *ngIf="!!data">
    <div class="menu">
      <div style="flex:1;"></div>
      <h1>{{ data.eventName }} Information</h1>
      <div style="flex:1;"></div>
      <div class="extra-filters">
        <div style="flex:1;"></div>
        <icon [icon]="'grow'" (click)="$event.stopPropagation(); expandAll()"></icon>
        <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll()"></icon>
      </div>
    </div>
  
    <public-informable *ngIf="data?.informable"
      [information]="data.informable.info"
      [assets]="data.assets"
      [singleSectionOnly]="false"
      [manualToggle]="true"
      [itemsInitClosed]="false"
      [sectionsInitClosed]="false"
      [showEmptyItems]="true"
    ></public-informable>
  </div>
  <div *ngIf="!loading && !data" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
</branding-wrapper>
    `,
    styles: [`
      ::ng-deep public-informable expandable-info { display: block; margin-top: 10px; .expanding-wrapper .wrapper-area { padding: 10px 5px; } }
      h1 { text-align: center; margin: 10px; }
      .inner { max-width: 800px; margin: 0px auto; display: block; }
      .menu { display: flex; width: 100%; justify-content: space-between; align-items: center; }
      icon { cursor: pointer; }

      `],
    standalone: true,
    imports: [BrandingWrapperComponent, CommonModule, IconComponent, InformablePublicComponent]
})
export class ShareEventInformationComponent extends ShareWrapper<ShareEventInformationComponent> {
    loading: boolean
    eventId: string
    data: EventInformationData
    inactiveUrlMessage = "The event information is not available at this time."
    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    @ViewChild(InformablePublicComponent) informable: InformablePublicComponent

    expandAll() {
      this.informable.expandAll()
    }

    collapseAll() {
      this.informable.collapseAll()
    }

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.eventId = params.id;      
          const url = `${this.api}/information/${this.eventId}`
          this.http.get(url).pipe(take(1)).subscribe((data: EventInformationData) => {
            this.data = data
            console.log(data)
            document.title = `${data.eventName} Information`
            this.loading = false;
          }, (error) => {
            console.log(error)
            this.loading = false;
            document.title = this.inactiveUrlMessage
          })
        } 
      })
    }

}

